"use client";
import type { RowData } from "@tanstack/react-table";

import type { RecordColumnDef } from "../column-types";
import { Checkbox } from "@/components/ui/checkbox";
import { SELECT_COLUMN_ID } from "./grid-metrics";

export function selectColumn<TData extends RowData>(): RecordColumnDef<TData, unknown> {
  return {
    id: SELECT_COLUMN_ID,
    size: 44,
    enableResizing: false,
    header: ({ table }) => (
      <Checkbox
        aria-label="Select all rows on this page"
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      />
    ),
    cell: ({ row }) => (
      <label className="absolute inset-0 flex cursor-pointer items-center justify-center">
        <Checkbox
          aria-label="Select row"
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
        />
      </label>
    ),
  };
}
